import { useBreadcrumb } from "features/breadcrumbs";
import { Box } from "@chakra-ui/react";
import PageHeader from "components/Page/PageHeader";
import colors from "core/resources/theme/colors";
import { SimpleGrid } from "@chakra-ui/layout";
import MeuFinanceiroCard from "./components/MeuFinanceiroCard";
import { AiOutlineFall, AiOutlineRise, AiOutlineSwap } from "react-icons/ai";
import { MdOutlineAttachMoney } from "react-icons/md";
import { TbZoomMoney } from "react-icons/tb";
import { GiReceiveMoney } from "react-icons/gi";
import history from "infra/helpers/history";
import Container from "components/Container";
import { checkPermission } from "infra/helpers/permission";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { Empty } from "antd";

function MeuFinanceiroPage() {
  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
  ]);

  const permissions = {
    demonstrativo: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro
        .DemonstrativoReceitaDespesa,
    ]),
    demonstrativoAnual: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro
        .DemonstrativoReceitaDespesaAnual,
    ]),
    receitas: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro.Receitas,
    ]),
    despesas: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro.TotalDespesas,
    ]),
    inadimplentes: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro.Inadimplentes,
    ]),
    prestacaoContas: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro.PrestacaoContas,
    ]),
    balancoFinanceiro: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro.BalancoFinanceiro,
    ]),
    composicaoReceitas: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro.ComposicaoReceitas,
    ]),
    composicaoReceitasHorizontal: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro
        .ComposicaoReceitasHorizontal,
    ]),
    despesasPorCategoria: checkPermission([
      PermissaoEnum.Backoffice.Relatorios.Financeiro.DespesasPorCategoria,
    ]),
  };

  const hasAtLeast1Permission = Object.values(permissions).some((v) => !!v);

  return (
    <>
      <Container>
        <PageHeader justifyContent="space-between" title="Financeiro" />

        <SimpleGrid
          columns={
            !hasAtLeast1Permission ? { xs: 1 } : { sm: 1, md: 3, lg: 3, xl: 3 }
          }
          gap="16px"
          mb="32px"
          mt="40px"
        >
          {!hasAtLeast1Permission ? (
            <Empty description="Você não tem permissão para acessar nenhum relatório" />
          ) : null}

          {permissions.demonstrativo ? (
            <Box
              onClick={() =>
                history.push("/relatorios/financeiro/receitas-despesas")
              }
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.lightGray}
                label="Demonstrativo Receitas e Despesas"
                icon={
                  <MdOutlineAttachMoney fontSize="24px" color={colors.gray} />
                }
              />
            </Box>
          ) : null}

          {permissions.demonstrativoAnual ? (
            <Box
              onClick={() =>
                history.push("/relatorios/financeiro/receitas-despesas-anual")
              }
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.lightGray}
                label="Demonstrativo Receitas e Despesas Anual"
                icon={
                  <>
                    <MdOutlineAttachMoney fontSize="24px" color={colors.gray} />
                    <MdOutlineAttachMoney fontSize="24px" color={colors.gray} />
                    <MdOutlineAttachMoney fontSize="24px" color={colors.gray} />
                  </>
                }
              />
            </Box>
          ) : null}

          {permissions.despesas ? (
            <Box
              onClick={() => history.push("/relatorios/financeiro/despesas")}
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.red100}
                label="Total de despesas"
                icon={<AiOutlineFall fontSize="24px" color={colors.red} />}
              />
            </Box>
          ) : null}

          {permissions.inadimplentes ? (
            <Box
              onClick={() =>
                history.push("/relatorios/financeiro/inadimplentes")
              }
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.red100}
                label="Inadimplentes"
                icon={<GiReceiveMoney fontSize="24px" color={colors.red} />}
              />
            </Box>
          ) : null}

          {permissions.receitas ? (
            <Box
              onClick={() => history.push("/relatorios/financeiro/receitas")}
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.green100}
                label="Receitas"
                icon={<AiOutlineRise fontSize="24px" color={colors.green} />}
              />
            </Box>
          ) : null}

          {permissions.composicaoReceitas ? (
            <Box
              onClick={() =>
                history.push("/relatorios/financeiro/composicao-receitas")
              }
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.green100}
                label="Receitas com Composição"
                icon={<AiOutlineRise fontSize="24px" color={colors.green} />}
              />
            </Box>
          ) : null}

          {permissions.composicaoReceitasHorizontal ? (
            <Box
              onClick={() =>
                history.push(
                  "/relatorios/financeiro/composicao-receitas-horizontal"
                )
              }
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.green100}
                label="Receitas com Composição Horizontal"
                icon={<AiOutlineRise fontSize="24px" color={colors.green} />}
              />
            </Box>
          ) : null}

          {permissions.despesasPorCategoria ? (
            <Box
              onClick={() =>
                history.push("/relatorios/financeiro/composicao-despesas")
              }
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.red100}
                label="Despesas com composição"
                icon={<AiOutlineFall fontSize="24px" color={colors.red} />}
              />
            </Box>
          ) : null}

          {permissions.balancoFinanceiro ? (
            <Box
              onClick={() =>
                history.push("/relatorios/financeiro/balanco-financeiro")
              }
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.blue200}
                label="Balanço financeiro"
                icon={<AiOutlineSwap fontSize="24px" color={colors.gray} />}
              />
            </Box>
          ) : null}

          {permissions.prestacaoContas ? (
            <Box
              onClick={() =>
                history.push("/relatorios/financeiro/prestacao-de-contas")
              }
              cursor="pointer"
            >
              <MeuFinanceiroCard
                iconBg={colors.blue200}
                label="Prestação de contas"
                icon={<TbZoomMoney fontSize="24px" color={colors.blue500} />}
              />
            </Box>
          ) : null}
        </SimpleGrid>
      </Container>
    </>
  );
}

export default MeuFinanceiroPage;
